import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";

export interface IPageState {
  pageInfo: any;
}

@Module({ dynamic: true, namespaced: true, store, name: "page" })
class Page extends VuexModule implements IPageState {
  // 页面缓存信息
  pageInfo: any = {
    classManage: {},
    classDetail: {},
    studyingList: {},
    storeCourse: {},
    orderManage: {},
    orderLine: {},
    studying: {}, // 学员管理-在读学员
    studyDetails: {},
    teacherMange: {},
    teacherDetails: {},
    storeStaff: {},
    rollCallRecordList: {},
    rollCallStudentList: {},
    timeoutNotPointList: {},
    afterClass: {},
    liveManage: {},
    integralLog: {},
    integralGoods: {},
    renewalList: {}, // 续费提醒-缴费提醒
    history: {}, // 学员管理-历史学员
    purchase: {}, // 学员管理-购课档案
    approveLog: {}, // 财务中心-审批记录
    approveLogAll: {},
    approveLogMine: {},
    approvalRule: {}, // 中心管理-审批规则
    approvalRuleList: {}, // 中心管理-审批规则-规则
    approvalRulePush: {}, // 中心管理-审批规则-推送
    recruitLatent: {}, // 招生管理-意向管理
    recruitLatentList: {}, // 招生管理-意向管理-意向学员
    recruitRecycleList: {}, // 招生管理-意向管理-回收列表
    recruitWaitingList: {}, // 招生管理-意向管理-待分配列表
    recruitFollowList: {}, // 招生管理-跟进记录
    recruitExperienceList: {}, // 招生管理-体验课
    sechduleTime: {},
    financialOrderList: {}, // 财务中心-订单管理-订单列表
    financialOrderLine: {}, // 财务中心-订单管理-订单明细
    financialOrderLog: {}, // 财务中心-订单管理-订单收款记录
    storeWalletTabDetail: {}, // 财务中心-乐沃收银-收支明细
    financialRefundRecord: {}, // 财务中心-退款记录
    financialPaymentRecord: {}, // 财务中心-收款记录
    storeEmployees: {}, // 中心管理-员工管理-中心员工
    makeUpLessonInfo: {}, // 点名记录-补课管理
    salary: {}, // 工资结算
    salaryTabStore: {}, // 工资结算-中心工资
    salaryTabAchievements: {}, // 工资结算-授课绩效
    salaryStaffList: {}, // 工资结算-员工工资列表
    teacherAndStudentInfo: {}, // 教师管理-教师学员
    teacherAndStudent: {}, // 教师管理tab
    areaCodePhoneNumber: {}, // 自己的手机区号
    guardianAreaCodePhoneNumber: {}, // 监护人手机区号
    experienceRecordSearch: {}, // 体验课-体验记录
    renewRecordSearch: {}, // 续费提醒-续费记录
    closingRecordSearch: {}, // 学员管理-结课记录
    storeTimetableJumps: {}, // 中心课表路由跳转
    afterClassExercises: {}, // 互动管理-课后练习-搜索列表
    timeTableSearch: {}, // 时间课表缓存;
    teacherTableSearch: {}, // 教师课表缓存
    classroomTableSearch: {}, // 教室课表缓存
    timeStoreDate: {}, // 时间课表时间选择
    classroomStoreDate: {}, // 教室课表时间选择
    teacherStoreDate: {}, // 教师课表时间选择
    exerciseDetails: {}, // 课后练习-练习明细页面缓存
    afterClassExercisesTab: {}, // 课后练习-tab切换缓存
    classDetailSigned: {}, // 班级详情已点名课时
    studentDetailSigned: {}, // 学员详情已点名课时
    resourceManagement: {}, // 数据中心-资源管理
    storeWallet: {}, // 门店钱包
    teachManageBirthdayStudent: {}, // 教务管理-学员管理-生日学员
  };
  latestRoute: string = ""; // 最后访问页面的路由name
  layoutFullScreenMode: boolean = false; // layout是否全屏模式
  dictionary = {
    //字典
    studentAppearLabelList: [
      {
        key: 1,
        value: "Walk_In",
      },
      {
        key: 2,
        value: "Call_In",
      },
      {
        key: 3,
        value: "Net_In",
      },
      {
        key: 4,
        value: "Call_Out",
      },
      {
        key: 5,
        value: "转介绍",
      },
    ],
  }; // 字典

  /*
      ! getters
    */

  /*
      ! mutations
    */

  @Mutation
  public SET_PAGE_INFO(data: { name: string; key: string; value: any }) {
    this.pageInfo[data.name][data.key] = data.value;
  }
  @Mutation
  public SET_LATEST_ROUTE(data: string) {
    this.latestRoute = data;
  }
  @Mutation
  public SET_LAYOUT_FULL_SCREEN_MODE(data: boolean) {
    this.layoutFullScreenMode = data;
  }

  /*
      ! actions
    */
}

export const PageModule = getModule(Page);
